// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    //  API_URL: 'https://x8wno0p02c.execute-api.us-east-1.amazonaws.com/dev/'

   API_URL:'https://dev.noc.mvnoc.ai/api',
   S3GATEWAY_URL:'https://dev.s3gateway.mvnoc.ai'
//  API_URL:'https://dev-test.noc.mvnoc.ai/api' 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
